import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import Logo from "../Logo"
import breakpoints from "../../styles/breakpoints"
import SocialLinks from "../SocialLinks"
import { LinkH300, LinkH200, LinkH200Normal } from "../NormalLink"
import { currentLocale } from "../../locale/languages"
import slugify from "../../utils/slugify"

const ContainerTop = styled.div`
  background-color: ${(props) => props.theme.colors.black800};
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: relative;

  &:before {
    content: "";
    z-index: 999;
    position: absolute;
    bottom: 100%;
    left: 0;
    height: 38px;
    width: 100%;
    background: url("data:image/svg+xml,%3csvg width='320' height='57' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 57V23.021c2.1872-.6288 4.6982-1.4944 6.8843-2.4181 2.6457-1.0997 6.0011-2.0994 7.4207-2.0994s7.098-1.7994 12.5183-3.8987c5.4204-2.0993 15.8093-3.299 22.9073-2.4992 7.098.7998 14.0025 1.1996 15.2285.7998 1.226-.3 10.8406-.4999 21.2941-.3 27.8114.4999 27.7468.4999 40.007-.8996 16.0029-1.7995 22.3911-1.7995 25.2303.1 1.8713 1.2995 4.0653 1.5994 10.647 1.2995 4.5815-.2 9.163-.8997 10.1309-1.4995 1.2905-.7998 6.969-.9997 17.616-.6998 9.0339.3 16.519.1 17.5515-.4998.968-.4999 4.3879-1.0997 7.5497-1.3996 8.3886-.5998 11.5504-1.1996 17.616-3.3989 3.549-1.2995 6.5818-1.6994 8.8403-1.3995 2.323.3999 4.4524 0 6.84-1.2996 3.0327-1.4995 5.4848-1.7994 18.0031-1.5995 8.0014.1 16.261-.2999 18.3258-.7997 3.1619-.7998 4.0653-.6998 4.9686.5998.8389 1.0996 2.5811 1.4995 7.3562 1.4995 4.0007 0 6.9044.3999 8.0014 1.2996.9034.7997 3.7426 1.6994 6.1946 1.9993 1.6087.1917 5.0368.6694 8.8684 1.198V57H0z' fill='%23313131' fill-rule='evenodd'/%3e%3c/svg%3e")
      top center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  ${breakpoints.md`
    &:before {
      z-index: 999;
      background: url("data:image/svg+xml,%3csvg width='1440' height='46' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 46V13.324c.8707.0462 1.8988.2876 2.749.6851 1.8047.791 10.5276 1.0284 37.8994.9493 19.5514 0 38.2003-.2374 41.509-.5538 3.3087-.2373 9.1741-.712 13.0844-1.0283 4.0606-.2374 9.6252-1.3448 12.4827-2.3732 3.008-1.0283 6.9182-1.8985 8.723-1.8985 1.8047 0 7.0685-.5537 11.5803-1.2657 7.5198-1.1074 44.3665-3.006 54.7438-2.7686 2.4063 0 5.1134.3955 6.0158.8701.752.3955 3.9102.791 6.9181.791 6.7678 0 27.0711 2.5314 37.298 4.6672 4.3614.9493 9.4748 1.6612 11.2796 1.6612 1.8047 0 5.2638.5538 7.6701 1.1866 2.4063.6329 7.0686 1.4239 10.5277 1.6612 3.3086.3164 7.0685.8702 8.1213 1.3448 1.2031.4746 2.4063.4746 3.7599 0 .9023-.4746 4.211-.6328 7.0685-.3955s10.678.4746 17.2954.5537c12.7836.2373 30.5302 1.0284 32.1845 1.503 1.6544.4746 17.145-.9493 28.7254-2.6105 6.1662-.8701 13.9868-1.6612 17.2955-1.6612 3.3086 0 16.5434-1.4238 29.1766-3.085l23.1608-3.1642 30.2293 1.1865c16.5435.6329 32.6357.9493 35.4932.6329 2.8575-.2373 25.2664-.3956 49.6303-.2373 64.8202.3955 64.6698.3955 93.2449-.712 37.2979-1.4239 52.187-1.4239 58.8043.0791 4.3615 1.0284 9.475 1.2657 24.8152 1.0284 10.678-.1582 21.356-.712 23.612-1.1866 3.0079-.6328 16.2426-.791 41.0578-.5537 21.0553.2373 38.501.079 40.9074-.3955 2.256-.3956 10.2268-.8702 17.5962-1.1075 19.5513-.4746 26.9207-.9493 41.0578-2.6896 8.2717-1.0283 15.3403-1.3448 20.604-1.1074 5.4143.3164 10.3773 0 15.942-1.0284 7.0685-1.1866 12.7835-1.4239 41.9601-1.2657 18.649.0791 37.8995-.2373 42.7122-.6328 7.3693-.6329 9.4748-.5538 11.5804.4746 1.9551.8702 6.0158 1.1866 17.145 1.1866 9.3245 0 16.0922.3164 18.649 1.0283 2.1055.6329 8.7228 1.3448 14.4379 1.5821 5.8653.2374 22.108 1.0284 36.0947 1.6612 40.9074 1.8986 53.3902 2.7687 65.4218 4.9045 6.1662 1.1075 12.7835 2.6896 14.5883 3.5597 2.7071 1.3448 4.5118 1.5821 10.5276 1.1866 3.9103-.3164 13.9868-.712 22.2585-.9492 8.2717-.2374 21.9576-1.424 30.5301-2.5314 12.934-1.6612 16.0923-1.8985 19.401-1.1075 2.5567.6329 12.3323.9493 27.9734.9493 13.2348-.0791 24.8152.2373 25.7175.6328 1.504.6329 20.7545-.079 30.5302-1.1074 2.256-.2373 11.1292-.3956 19.5513-.3956 9.7757 0 17.7466-.3955 21.8073-1.1074 3.459-.712 6.7677-.9493 7.219-.6329.5762.4547 11.3635.4738 39.6315.1966V46H0z' fill='%23313131' fill-rule='evenodd'/%3e%3c/svg%3e") top center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  `};

  ${breakpoints.md`
    justify-content: space-between;
    flex-direction: row;
    padding: 34px 34px 48px 34px;
    align-items: center;
  `};
  ${breakpoints.lg`
    padding: 34px 34px 160px 34px;
  `};
`

const ContainerBottom = styled.div`
  padding: 24px 16px;
  background-color: #272727;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${breakpoints.md`
    flex-direction: row;
    padding: 16px 48px;
    align-items: center;
  `};
  ${breakpoints.lg`
    padding: 48px 160px;
  `};
`

const Nav = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  ${breakpoints.md`
    margin: 0;
    flex-direction: row;
    align-items: center;
  `};
`

const NavBottom = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  ${breakpoints.md`
    margin: 0;
    flex-direction: row;
    align-items: center;
  `};
`

const Item = styled(LinkH300)`
  color: ${(props) => props.theme.colors.white};
  padding: 8px 0;
  ${breakpoints.md`
    padding: 0 16px;
    &:last-child {
      padding-right: 0;
    }
  `};
`

const ItemBottom = styled(LinkH200)`
  padding: 8px 0;
  color: ${(props) => props.theme.colors.black400};
  span {
    color: ${(props) => props.theme.colors.white};
  }
  ${breakpoints.md`
    padding: 0 16px;
    &:first-child {
      padding-left: 0;
    }
  `};
`

const ItemBottomNormalLink = styled(LinkH200Normal)`
  padding: 8px 0;
  color: ${(props) => props.theme.colors.black400};
  span {
    color: ${(props) => props.theme.colors.white};
  }
  ${breakpoints.md`
    padding: 0 16px;
    &:first-child {
      padding-left: 0;
    }
  `};
`

const Brand = styled(Link)`
  width: 47px;
  height: 56px;
  margin: 12px 0;
  ${breakpoints.md`
    width: 60px;
    height: 72px;
  `};
`

const Footer = ({ data, pageContext }) => {
  const { name, facebook, instagram, youtube } = data.sanityCompanyInfo
  const { locale } = pageContext
  const setLocaleInUrl = currentLocale !== locale ? `${locale}/` : ""
  const navItems = [
    data.sanityAllVacanciesPage,
    data.sanityOurProcessPage,
    data.sanityAboutUsPage,
    data.sanityStoriesPage,
    data.sanityFaqPage,
    data.sanityContactPage,
  ]

  const { sanityTermsPage, sanityPrivacyPage } = data

  return (
    <footer>
      <ContainerTop>
        <Brand to="/">
          <Logo logoTheme="Light" />
        </Brand>
        <Nav>
          {navItems &&
            locale &&
            navItems.map((item) => (
              <Item
                key={`${item.id}`}
                to={`/${setLocaleInUrl}${slugify(
                  item._rawLocaleTitle[locale]
                )}`}
                activeClassName="active"
              >
                {item._rawLocaleTitle[locale]}
              </Item>
            ))}
        </Nav>
      </ContainerTop>
      <ContainerBottom>
        <NavBottom>
          {name && (
            <ItemBottom to="/">
              ©<span> {name}</span>
            </ItemBottom>
          )}
          {sanityTermsPage && locale && (
            <ItemBottom
              to={`/${setLocaleInUrl}${slugify(
                sanityTermsPage._rawLocaleTitle[locale]
              )}`}
            >
              {sanityTermsPage._rawLocaleTitle[locale]}
            </ItemBottom>
          )}
          {sanityPrivacyPage && locale && (
            <ItemBottom
              to={`/${setLocaleInUrl}${slugify(
                sanityPrivacyPage._rawLocaleTitle[locale]
              )}`}
            >
              {sanityPrivacyPage._rawLocaleTitle[locale]}
            </ItemBottom>
          )}
        </NavBottom>
        <SocialLinks
          facebook={facebook}
          instagram={instagram}
          youtube={youtube}
        />
      </ContainerBottom>
    </footer>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query footer {
        sanityAllVacanciesPage {
          id
          _rawLocaleTitle
        }
        sanityOurProcessPage {
          id
          _rawLocaleTitle
        }
        sanityAboutUsPage {
          id
          _rawLocaleTitle
        }
        sanityStoriesPage {
          id
          _rawLocaleTitle
        }
        sanityFaqPage {
          id
          _rawLocaleTitle
        }
        sanityContactPage {
          id
          _rawLocaleTitle
        }
        sanityTermsPage {
          id
          _rawLocaleTitle
        }
        sanityPrivacyPage {
          id
          _rawLocaleTitle
        }
        sanityCompanyInfo {
          name
          facebook
          instagram
          youtube
        }
      }
    `}
    render={(data) => <Footer data={data} {...props} />}
  />
)
